export const statusOptions = [
  { value: 'todos', title: 'Todos' },
  { value: 'incompleta', title: 'Incompleta' },
  { value: 'por enviar', title: 'Por enviar' },
  { value: 'en revisión', title: 'En revisión' },
  { value: 'en trámite', title: 'En trámite' },
  { value: 'rechazada', title: 'Rechazada' },
  { value: 'por configurar', title: 'Por configurar' }
];